import { useState, useEffect } from 'react';
import {
  User,
  Edit,
  Trash2,
  X,
  Save,
  Phone,
  Mail,
  MapPin,
} from 'lucide-react';
import httpClient from '../api/axios';
import { useSelector, useDispatch } from 'react-redux';
import {
  setUserDetails,
  setUserId,
  setLoginStatus,
} from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const userId = useSelector((state) => state.auth.userId);

  const fetchUser = async () => {
    try {
      const res = await httpClient.get(`api/users/${userId}`);
      const data = res?.data?.data;
      console.log(data);
      if (data) {
        setUser(data);
        setEditData(data);
        // dispatch(setUserDetails(data));
        // dispatch(setUserId(data._id));
      } else {
        setError('No user data found.');
      }
    } catch (err) {
      console.error('Failed to fetch user:', err.message);
      setError('Error fetching user data. Please try again.');
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleEditClick = () => setIsModalOpen(true);

  const handleSave = async () => {
    if (!editData.name || !editData.address) {
      setError('Name and Address are required.');
      return;
    }

    setError(null);
    setSaving(true);

    try {
      const res = await httpClient.put(
        `/api/users/${userId}/profile`,
        editData
      );
      const updatedUser = res?.data?.user;
      setUser(updatedUser);
      setEditData(updatedUser);
      dispatch(setUserDetails(updatedUser));
      setIsModalOpen(false);
    } catch (err) {
      console.error('Failed to update user:', err.message);
      setError('Error updating profile. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (
      window.confirm('Are you sure you want to delete your profile?')
    ) {
      try {
        await httpClient.delete(`/api/users/${userId}`);
        dispatch(setUserDetails({}));
        dispatch(setUserId(''));
        dispatch(setLoginStatus(false));
        setUser(null);
        navigate('/login');
      } catch (err) {
        console.error('Failed to delete user:', err.message);
        setError('Error deleting user. Please try again.');
      }
    }
  };

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // if (loading) {
  //   return (
  //     <div className='flex items-center justify-center min-h-screen bg-gray-50'>
  //       <div className='text-center'>
  //         <div className='w-16 h-16 border-4 border-t-emerald-500 border-emerald-200 rounded-full animate-spin mx-auto'></div>
  //         <p className='mt-4 text-gray-600'>Loading profile...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // if (!user) {
  //   return (
  //     <div className='flex items-center justify-center min-h-screen bg-gray-50'>
  //       <div className='bg-white p-8 rounded-lg shadow-md text-center max-w-md w-full'>
  //         <User size={48} className='mx-auto text-gray-400' />
  //         <h2 className='mt-4 text-xl font-semibold text-gray-700'>
  //           No Profile Found
  //         </h2>
  //         <p className='mt-2 text-gray-500'>
  //           No user data is available.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className='min-h-screen bg-gray-50 pb-16'>
      <div className='bg-gradient-to-r from-emerald-400 to-teal-500 text-white py-12 rounded-b-3xl shadow-lg text-center relative mt-[100px]'>
        <div className='relative z-10'>
          <h2 className='text-2xl font-bold'>{user?.name}</h2>
          <p className='text-emerald-50'>{user?.email}</p>
        </div>
      </div>

      <div className='w-full max-w-xl mx-auto mt-8 px-4'>
        {error && (
          <div className='mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded'>
            <p className='text-red-700'>{error}</p>
          </div>
        )}

        <div className='bg-white rounded-xl shadow-md overflow-hidden mb-6'>
          <div className='p-6 space-y-4'>
            <div className='flex items-center'>
              <div className='bg-emerald-100 p-2 rounded-full mr-4'>
                <User size={20} className='text-emerald-600' />
              </div>
              <div>
                <p className='text-sm text-gray-500'>Name</p>
                <p className='font-medium text-gray-800'>
                  {user?.name}
                </p>
              </div>
            </div>

            <div className='flex items-center'>
              <div className='bg-emerald-100 p-2 rounded-full mr-4'>
                <Mail size={20} className='text-emerald-600' />
              </div>
              <div>
                <p className='text-sm text-gray-500'>Email</p>
                <p className='font-medium text-gray-800'>
                  {user?.email}
                </p>
              </div>
            </div>

            <div className='flex items-center'>
              <div className='bg-emerald-100 p-2 rounded-full mr-4'>
                <Phone size={20} className='text-emerald-600' />
              </div>
              <div>
                <p className='text-sm text-gray-500'>Phone</p>
                <p className='font-medium text-gray-800'>
                  {user?.phone}
                </p>
              </div>
            </div>

            <div className='flex items-center'>
              <div className='bg-emerald-100 p-2 rounded-full mr-4'>
                <MapPin size={20} className='text-emerald-600' />
              </div>
              <div>
                <p className='text-sm text-gray-500'>Address</p>
                <p className='font-medium text-gray-800'>
                  {user?.address}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3'>
          <button
            onClick={handleEditClick}
            className='flex-1 bg-emerald-500 hover:bg-emerald-600 text-white py-3 rounded-lg font-medium transition duration-200 flex items-center justify-center'
          >
            <Edit size={18} className='mr-2' />
            Edit Profile
          </button>

          <button
            onClick={handleDelete}
            className='flex-1 bg-red-500 hover:bg-red-600 text-white py-3 rounded-lg font-medium transition duration-200 flex items-center justify-center'
          >
            <Trash2 size={18} className='mr-2' />
            Delete Profile
          </button>
        </div>
      </div>

      {isModalOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4'>
          <div className='bg-white p-6 rounded-xl shadow-xl w-full max-w-md animate-fade-in'>
            <div className='flex justify-between items-center mb-6'>
              <h3 className='text-xl font-semibold text-gray-800'>
                Edit Profile
              </h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className='text-gray-500 hover:text-gray-700'
              >
                <X size={24} />
              </button>
            </div>

            {error && (
              <div className='mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded'>
                <p className='text-red-700'>{error}</p>
              </div>
            )}

            <div className='space-y-4'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Name
                </label>
                <input
                  type='text'
                  name='name'
                  value={editData.name}
                  onChange={handleChange}
                  className='w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent'
                  placeholder='Enter your name'
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Email
                </label>
                <input
                  type='email'
                  name='email'
                  value={editData.email}
                  disabled
                  className='w-full bg-gray-100 cursor-not-allowed border border-gray-300 p-3 rounded-lg'
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Phone
                </label>
                <input
                  type='text'
                  name='phone'
                  value={editData.phone}
                  disabled
                  className='w-full bg-gray-100 cursor-not-allowed border border-gray-300 p-3 rounded-lg'
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Address
                </label>
                <input
                  type='text'
                  name='address'
                  value={editData.address}
                  onChange={handleChange}
                  className='w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent'
                  placeholder='Enter your Address'
                />
              </div>
            </div>

            <div className='mt-6 flex justify-end'>
              <button
                onClick={handleSave}
                disabled={saving}
                className='bg-emerald-500 hover:bg-emerald-600 text-white py-3 px-6 rounded-lg font-medium transition duration-200 flex items-center'
              >
                {saving ? (
                  <>
                    <div className='h-4 w-4 border-2 border-t-white border-white/30 rounded-full animate-spin mr-2'></div>
                    Saving...
                  </>
                ) : (
                  <>
                    <Save size={18} className='mr-2' />
                    Save
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
